import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-135c773a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "address-list"
};
const _hoisted_2 = {
  class: "pro-box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, [/*#__PURE__*/_createTextVNode(" 售后原因 "), /*#__PURE__*/_createElementVNode("span", {
  class: "required"
}, "*")], -1));
const _hoisted_4 = {
  key: 0,
  class: "apply_reson_type"
};
const _hoisted_5 = {
  key: 1,
  class: "placeholder"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/after_sale/selectRight.png",
  alt: "",
  class: "right"
}, null, -1));
const _hoisted_7 = {
  key: 0,
  class: "texarea"
};
const _hoisted_8 = {
  class: "label"
};
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 上传凭证 ");
const _hoisted_10 = {
  key: 0,
  class: "required"
};
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" （有助于帮您快速处理） ");
const _hoisted_12 = {
  key: 0,
  class: "tips"
};
const _hoisted_13 = {
  class: "update-list"
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src", "onClick"];
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  key: 2,
  class: "loading"
};
const _hoisted_18 = ["src", "onClick"];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/after_sale/after_sale_camera.png",
  alt: ""
}, null, -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, [/*#__PURE__*/_createTextVNode(" 上传凭证"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("支持图片/视频 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("（最多6张） ")], -1));
const _hoisted_21 = [_hoisted_19, _hoisted_20];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "update-bt"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/after_sale/after_sale_camera.png",
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, [/*#__PURE__*/_createTextVNode(" 上传凭证"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("支持图片/视频 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("（最多6张） ")])], -1));
const _hoisted_23 = {
  class: "texarea"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, [/*#__PURE__*/_createTextVNode(" 补充描述 "), /*#__PURE__*/_createElementVNode("span", {
  class: "required"
}, "*")], -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, [/*#__PURE__*/_createTextVNode(" 可能需要补发，请预留补发商品收货地址 "), /*#__PURE__*/_createElementVNode("span", {
  class: "required"
}, "*")], -1));
const _hoisted_26 = {
  class: "info"
};
const _hoisted_27 = {
  class: "userinfo"
};
const _hoisted_28 = {
  class: "tel"
};
const _hoisted_29 = {
  class: "detail"
};
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://p6.moimg.net/md/after_sale/selectRight.png",
  alt: "",
  class: "right"
}, null, -1));
const _hoisted_31 = {
  class: "btn-box"
};
const _hoisted_32 = ["disabled"];
const _hoisted_33 = {
  class: "dialog",
  style: {
    "width": "100%",
    "height": "100%",
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "background": "none"
  }
};
const _hoisted_34 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompProCard = _resolveComponent("CompProCard");
  const _component_van_uploader = _resolveComponent("van-uploader");
  const _component_van_field = _resolveComponent("van-field");
  const _component_Form = _resolveComponent("Form");
  const _component_van_picker = _resolveComponent("van-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_VImage = _resolveComponent("VImage");
  const _component_van_overlay = _resolveComponent("van-overlay");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Form, {
    modelValue: $data.from,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.from = $event),
    onSubmit: $options.onSubmit,
    "label-width": "2.1rem"
  }, {
    default: _withCtx(() => {
      var _$data$dialog_btn$fin, _$data$dialog_btn$fin2, _$data$dialog_btn$fin3;
      return [_createElementVNode("div", _hoisted_2, [$setup.PInfo.id && $setup.PInfo.name && $setup.PInfo.wb_logo_1 ? (_openBlock(), _createBlock(_component_CompProCard, {
        key: 0,
        pro_info: {
          pro_id: $setup.PInfo.id,
          name: $setup.PInfo.name,
          url: $setup.PInfo.wb_logo_1
        }
      }, null, 8, ["pro_info"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
        class: "select",
        onClick: _cache[0] || (_cache[0] = $event => $data.orderRefundShow = true)
      }, [_hoisted_3, $data.apply_reson_name ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($data.apply_reson_name), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_5, "请选择")), _hoisted_6]), $data.apply_reson_name ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, (_$data$dialog_btn$fin = $data.dialog_btn.find(item => item.type == $data.from.apply_reson_type)) !== null && _$data$dialog_btn$fin !== void 0 && _$data$dialog_btn$fin.img_required ? (_openBlock(), _createElementBlock("span", _hoisted_10, "*")) : _createCommentVNode("", true), _hoisted_11]), (_$data$dialog_btn$fin2 = $data.dialog_btn.find(item => item.type == $data.from.apply_reson_type)) !== null && _$data$dialog_btn$fin2 !== void 0 && _$data$dialog_btn$fin2.img_des ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString((_$data$dialog_btn$fin3 = $data.dialog_btn.find(item => item.type == $data.from.apply_reson_type)) === null || _$data$dialog_btn$fin3 === void 0 ? void 0 : _$data$dialog_btn$fin3.img_des), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.from.fileList, (item, idx) => {
        return _openBlock(), _createElementBlock("div", {
          class: "list",
          key: idx
        }, [_createElementVNode("div", {
          class: "icon-closs delete",
          onClick: _withModifiers($event => $options.deleteImg(idx), ["stop"])
        }, null, 8, _hoisted_14), item.file_type == 'video' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [item.loaded ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.$imgUrlFilter(item.video_cover, Math.round(216 * $data.domPixelRatio())),
          onClick: $event => $options.openBig(item)
        }, null, 8, _hoisted_15)) : _createCommentVNode("", true), item.loaded ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          onClick: $event => $options.openBig(item),
          class: "play-icon"
        }, null, 8, _hoisted_16)) : _createCommentVNode("", true), !item.loaded ? (_openBlock(), _createElementBlock("div", _hoisted_17)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _ctx.$imgUrlFilter(item.url, Math.round(216 * $data.domPixelRatio())),
          onClick: $event => $options.openBig(item)
        }, null, 8, _hoisted_18))]);
      }), 128)), $data.from.fileList.length < 6 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [$data.env.isModianIos() || $data.env.isModianAndroid() ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "update-bt",
        onClick: _cache[1] || (_cache[1] = (...args) => $options.appUpdate && $options.appUpdate(...args))
      }, _hoisted_21)) : (_openBlock(), _createBlock(_component_van_uploader, {
        key: 1,
        deletable: "",
        accept: "image/*, video/*",
        "max-count": "6",
        "after-read": $options.afterRead
      }, {
        default: _withCtx(() => [_hoisted_22]),
        _: 1
      }, 8, ["after-read"]))], 64)) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createVNode(_component_van_field, {
        modelValue: $data.from.apply_reson_content,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.from.apply_reson_content = $event),
        class: "texarea-input",
        rows: "2",
        autosize: "",
        label: "",
        type: "textarea",
        maxlength: "200",
        placeholder: "请您详细填写申请说明",
        "show-word-limit": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", {
        class: "address",
        onClick: _cache[3] || (_cache[3] = (...args) => $options.toAddressList && $options.toAddressList(...args))
      }, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createTextVNode(_toDisplayString($data.from.address.address_name) + " ", 1), _createElementVNode("span", _hoisted_28, _toDisplayString($data.from.address.address_mobile), 1)]), _createElementVNode("div", _hoisted_29, _toDisplayString($data.from.address.province) + " " + _toDisplayString($data.from.address.city) + " " + _toDisplayString($data.from.address.county) + " " + _toDisplayString($data.from.address.street) + " " + _toDisplayString($data.from.address.address), 1), _hoisted_30])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("button", {
        class: _normalizeClass(['frombtn', {
          ready: $data.readyBtn
        }]),
        disabled: !$data.readyBtn,
        onClick: _cache[4] || (_cache[4] = (...args) => $options.readyBtnSubmit && $options.readyBtnSubmit(...args)),
        round: "",
        block: "",
        type: "primary",
        "native-type": "submit"
      }, " 提交申请 ", 10, _hoisted_32)])];
    }),
    _: 1
  }, 8, ["modelValue", "onSubmit"]), _createVNode(_component_van_popup, {
    show: $data.quhao,
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_picker, {
      columns: $data.payList,
      onConfirm: $options.onConfirmquhao,
      onCancel: _cache[6] || (_cache[6] = $event => $data.quhao = false)
    }, null, 8, ["columns", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $data.dialogImgShow,
    onClick: _cache[8] || (_cache[8] = $event => $data.dialogImgShow = false)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [$data.imgBigUrl.file_type == 'video' ? (_openBlock(), _createElementBlock("video", {
      key: 0,
      onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"])),
      controls: "",
      muted: "",
      autoplay: "",
      playsinline: "true",
      "webkit-playsinline": "true",
      style: {
        "max-width": "80%",
        "max-height": "60%"
      },
      src: $data.imgBigUrl.videoUrl
    }, null, 8, _hoisted_34)) : (_openBlock(), _createBlock(_component_VImage, {
      key: 1,
      width: "100%",
      fit: "contain",
      src: $data.imgBigUrl.url
    }, null, 8, ["src"]))])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_action_sheet, {
    show: $data.orderRefundShow,
    actions: $data.dialog_btn,
    onSelect: $options.op,
    onClose: $options.dialogBack,
    onCancel: $options.dialogBack,
    "close-on-click-overlay": true,
    "cancel-text": "取消"
  }, null, 8, ["show", "actions", "onSelect", "onClose", "onCancel"])]);
}